import { Query } from '@apollo/client/react/components';
import React from 'react';
import {
  PublishedDatasourceCustomSqlDocument,
  PublishedDatasourceCustomSqlQuery,
  PublishedDatasourceCustomSqlQueryVariables
} from '../../../../../gen-src/queries';
import { RenderQueryResult } from '../renderQueryResult';
import { CustomSQLTable, CustomSqlTextLink } from './CustomSqlDialog';

export type PublishedDatasourceCustomSqlQueryWrapperProps = {
  readonly publishedDatasourceId: string;
};

export function PublishedDatasourceCustomSqlQueryWrapper(props: PublishedDatasourceCustomSqlQueryWrapperProps): JSX.Element {

  return (
    <Query<PublishedDatasourceCustomSqlQuery, PublishedDatasourceCustomSqlQueryVariables>
      query={PublishedDatasourceCustomSqlDocument}
      variables={{ vizportalUrlId: props.publishedDatasourceId }}
    >
      {result => <RenderQueryResult result={result} renderers={{
        renderData: renderCustomSqlQueries
      }} />}
    </Query>
  )
}

function renderCustomSqlQueries(data: PublishedDatasourceCustomSqlQuery): JSX.Element | null {
  const datasource = data && data.publishedDatasources ? data.publishedDatasources[0] : null;
  if (!datasource) {
    return null;
  }

  const customSqlMap = new Map();
  datasource.fields.forEach((field) => {
    if (field.__typename === 'ColumnField') {
      field.columns.forEach((column) => {
        if (column.table?.__typename === 'CustomSQLTable') {
          customSqlMap.set(column.table.id, column.table);
        }
      });
    }
  });

  if (customSqlMap.size === 0) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const customSqlTables: Array<CustomSQLTable> = Array.from(customSqlMap.values());
  return (
    <CustomSqlTextLink
      containsUnsupportedCustomSql={customSqlTables.some(table => table.isUnsupportedCustomSql ?? false)}
      customSQLTables={customSqlTables}
      contentType={datasource.__typename}
    />
  );
}
